// QQ 意见反馈交流群加群二维码
export const QQ_CHAT = 'http://img.yqingke.com/tupian/%E6%84%8F%E8%A7%81%E5%8F%8D%E9%A6%88QQ%E7%BE%A4.png?e=1716304471&token=4EW8oM-qgCN7vmTFT0f2XPxiDSmhzBCYRsE5A2fZ:zYBJFO-kPu1uJTwEvSoE5mn7T34='

// 微信 意见反馈家刘群加群二维码
export const WX_CHAT = 'http://img.yqingke.com/tupian/%E6%84%8F%E8%A7%81%E5%8F%8D%E9%A6%88%E5%BE%AE%E4%BF%A1%E7%BE%A4.png?e=1716304499&token=4EW8oM-qgCN7vmTFT0f2XPxiDSmhzBCYRsE5A2fZ:57E3-E-bf1vSkff92e4hIcKyaHQ='

// 邻话网站 - logo
export const NETWORK_LOGP = 'http://img.yqingke.com/tupian/%E7%BD%91%E7%AB%99logo.jpg?e=1716388663&token=4EW8oM-qgCN7vmTFT0f2XPxiDSmhzBCYRsE5A2fZ:sOaTJ7duBcn3yHpt1lc77Wbd1hM='

// 用户头像悬窗背景图片
export const AVATAR_HEADER_BG = 'http://img.yqingke.com/tupian/%E8%83%8C%E6%99%AF%E5%9B%BE.png?e=1716703548&token=4EW8oM-qgCN7vmTFT0f2XPxiDSmhzBCYRsE5A2fZ:0acf8jER4Bgr3PEZHVNCjKWSju8='

// 默认头像兜底图：接口返回的 avatar 为空 / 匿名用户 / 图片 404 时统一用它，
// 避免 <img src=""> 渲染成裂图。
//
// 原来这里是 https://img.shiyit.com/20240123_1705973581037.png，但该域名现在 443
// 端口拒绝连接（curl: (7) Failed to connect），也就是说兜底之后依然是裂图，还要先
// 白等一次 TCP 失败。改成内联 SVG：零请求、不依赖外部域名、永不失效。
export { DEFAULT_AVATAR_URI as DEFAULT_AVATAR } from '@/utils/image'

// 图片 CDN 相关常量转出一层，页面里 import 一个 '@/constant' 就够。
// 定义放在 ./cdn.js 而不是本文件，是为了避开 constant/index → utils/image → constant/index
// 的循环依赖（utils/image.js 自己要用 IMG_CDN_URL），详见那边的说明。
export { IMG_CDN_URL, IMG_CDN_HOST, cdnUrl, DEFAULT_USER_COVER, SITE_LOGO_144 } from './cdn'

// 个人中心tab类型
export const articleType = {
  POST: 0, // 帖子
  CONFESSIONWALL: 1, // 同校
  LIKE: 2, // 点赞
  COMMENT: 3, // 评论
  COLLECT: 4, // 收藏
}
// 点赞类型
export const likeType = {
  ARTICLE: 0, // 帖子
  COMMENT: 1, // 评论
  CONFESSION: 2 // 同校
}
// 评论类型
export const commentType = {
  COMMENT: 1, // 评论
  ARTICLE: 2, // 帖子
  CONFESSION: 3 // 同校
}

// 内容审核状态。帖子和评论共用同一套 is_publish 语义，
// 后端定义见 pp-back 的 com.shiyi.common.ReviewConstants
export const auditState = {
  PUBLISHED: 1, // 审核通过，对外可见
  AUDITING: 2, // 审核中，只有作者自己看得到
  REJECTED: 3 // 审核不通过，只有作者自己看得到
}

// 文章审核情况
//
// 修了两个既有 bug：
// 1. 「审核不通过」原来写的是 value: '3' 字符串，而后端下发的是数字 3，
//    调用方用 === 严格比较永远匹配不到，未通过状态等于从来没生效过；
// 2. 第一项的键名拼错成 lable。
export const articleAuditStatus = [
  {
    label: 'PASS',
    value: auditState.PUBLISHED,
    text: '审核通过',
    textColor: '#3a8ee6'
  },
  {
    label: 'AUDITING',
    value: auditState.AUDITING,
    text: '审核中',
    textColor: '#ff9a3c'
  },
  {
    label: 'NOPASS',
    value: auditState.REJECTED,
    text: '审核不通过',
    textColor: '#f56c6c'
  }
]

// 需要在个人中心打角标的审核态及其文案。
// 审核通过不在其中：正常内容不该额外挂标签。
const AUDIT_BADGE_MAP = {
  [auditState.AUDITING]: {
    key: 'auditing',
    text: '审核中',
    // text 是列表角标上的短标签，tip 是点击时提示用的完整句子。
    // 列表里只展示 text —— 「审核中」本身自解释，展开一整行说明只会把卡片撑散。
    // tip 要能独立成句，因为提示里不会再回显 text。
    tip: '审核中，仅自己可见，通过后其他人才能看到'
  },
  [auditState.REJECTED]: {
    key: 'rejected',
    text: '审核未通过',
    tip: '审核未通过'
  }
}

/**
 * 取内容的审核态展示信息。
 *
 * 不返回未通过原因：产品上决定不向用户展示 reviewResult。
 * 后端仍然在 /v1/post/selectArticleByUserId 和 /v1/comment/getMyComment 里下发该字段
 * （见 ApiArticleListVO / MyCommentVO 的 reviewResult），以后要展示直接取 item.reviewResult 即可。
 *
 * @param {Object} item 帖子或评论，需要带 isPublish
 * @returns {null | { key: string, text: string, tip: string }}
 *          返回 null 表示这条内容正常，不需要打任何标签
 */
export function getAuditBadge (item) {
  if (!item) return null
  // 后端历史数据可能是字符串 '2'，统一转数字再比对，不要用 === 直接比
  const state = Number(item.isPublish)
  const badge = AUDIT_BADGE_MAP[state]
  return badge ? { ...badge } : null
}

/**
 * 内容是否对外可见。不可见的内容不应该有点赞/收藏这类对外互动入口。
 * 详情页作者可以进去预览自己审核中 / 未通过的帖子（/v1/post/info 已按登录人放开）。
 *
 * @param {Object} item 帖子或评论
 * @returns {boolean}
 */
export function isAuditPublished (item) {
  // isPublish 缺失时按可见处理：点赞/收藏等 tab 的列表本来就不下发这个字段，
  // 默认值取反会把正常内容误判成待审核
  if (!item || item.isPublish === undefined || item.isPublish === null) return true
  return Number(item.isPublish) === auditState.PUBLISHED
}



// 是否匿名
export const isAnonymous = {
  YES: 1, // 是匿名
  NO: 0 // 否
}

// 关注状态。后端定义见 pp-back 的 com.shiyi.enums.FollowStatusEnum，
// 取值同时用于 b_followed.status 和接口下发的 followStatus，两边编号一致。
//
// PENDING 只会出现在「对方是私密账号」的场景：关注请求要本人同意才生效。
// 原来前端只有 hasFollower 一个布尔，加这套常量的原因是布尔表达不了三态 ——
// 「已申请」既不能显示成已关注（内容其实还看不到），也不能显示成未关注
// （再点一次会撞上「关注申请已提交」的报错）。
export const FOLLOW_STATUS = {
  NONE: 0, // 未关注
  FOLLOWED: 1, // 已关注
  PENDING: 2 // 已申请，等待对方同意
}

/**
 * 关注按钮文案。
 *
 * 抽成函数而不是写死映射表，是因为「已关注」在互关时要显示成「已互关」，
 * 而这个判断散在粉丝列表、关注列表、搜索结果好几个地方，各写一遍必然分叉。
 *
 * @param {Number} followStatus 见 FOLLOW_STATUS
 * @param {Boolean} mutual 对方是否也关注了我，仅在已关注时影响文案
 * @returns {String}
 */
export function getFollowLabel (followStatus, mutual = false) {
  if (Number(followStatus) === FOLLOW_STATUS.PENDING) return '已申请'
  if (Number(followStatus) === FOLLOW_STATUS.FOLLOWED) return mutual ? '已互关' : '已关注'
  return '关注'
}

/**
 * 把接口下发的用户信息归一成关注状态。
 *
 * 存在的意义是兼容：followStatus 是本次新增的字段，帖子详情、@候选人等一部分
 * 接口暂时只下发 hasFollower。缺字段时退回布尔判断，不至于把已关注显示成未关注。
 *
 * @param {Object} user 带 followStatus 或 hasFollower / hasFollowed 的对象
 * @returns {Number} 见 FOLLOW_STATUS
 */
export function resolveFollowStatus (user) {
  if (!user) return FOLLOW_STATUS.NONE
  const status = Number(user.followStatus)
  // 只有非 0 的 followStatus 才算「服务端明确表态」，0 要继续往下走布尔兜底。
  //
  // 不能写成「followStatus 非 null 就用它」：后端 UserInfoVO.followStatus 是个
  // Integer 字段、默认值就是 0，接口忘了显式赋值时照样会序列化出 followStatus: 0，
  // 于是这个默认值把 hasFollower: true 顶掉，已关注被显示成未关注 —— 帖子详情就踩过这个坑。
  //
  // 反过来，0 与布尔标记同时出现时以布尔为准是安全的：两者都由服务端同一段逻辑成对赋值，
  // 真的未关注时布尔一定是 false（注销/封禁账号的脱敏也会把两者一起收敛成未关注）。
  if (user.followStatus !== undefined && user.followStatus !== null &&
    !Number.isNaN(status) && status !== FOLLOW_STATUS.NONE) {
    return status
  }
  // hasFollowed 是搜索接口的字段名，hasFollower 是其它接口的，两个都要兜到
  return (user.hasFollower || user.hasFollowed) ? FOLLOW_STATUS.FOLLOWED : FOLLOW_STATUS.NONE
}